import styled from 'styled-components';
import { black20, spacer12, spacer56, Text } from '@spotify-internal/encore-web';
import React from 'react';

import { urlForImage, srcSetForImage } from 'utils/sanity';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { DIR } from 'data/market/types';

import { CategoryCardComponent } from './CategoryCardComponent';

interface CardProps {
  backgroundColor: string;
}

const Card = styled.div<CardProps>`
  height: 92px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  background-color: ${props => props.backgroundColor};
`;

const Image = styled.img<{ dir: DIR }>`
  height: 64px;
  position: absolute;
  top: 25px;
  box-shadow: 0 2px 4px 0 ${black20};

  // This works because in RTL the 'right' property is given precedence to the left and vv for LTR.
  right: calc(100% - 64px + 19px);
  left: calc(100% - 64px + 19px);
  transform: ${({ dir }) => (dir === 'ltr' ? 'rotate(25deg)' : 'rotate(-25deg) scaleX(-1)')};
`;

const CardTitle = styled(Text)`
  display: block;
  padding: ${spacer12};
  position: relative;
  padding-inline-end: ${spacer56};
`;

export const SideImageCategoryCard: CategoryCardComponent = ({ category, vertical }) => {
  const {
    market: { dir },
  } = useServerSideConstants();
  return (
    <Card backgroundColor={category.backgroundColor.hex}>
      <Image
        srcSet={srcSetForImage({ source: category.image.asset, maxWidth: 64, vertical })}
        src={urlForImage({ source: category.image.asset, maxWidth: 64, vertical })}
        aria-hidden="true"
        width={64}
        height={64}
        dir={dir}
      />
      <CardTitle variant="bodyMediumBold">{category.title}</CardTitle>
    </Card>
  );
};
